const RenderCardTitle = ({editInfo, pickupIndex, classes, pickupIdToNumberMap}) => {
    const { pickupId, proNumber, pieces, packagingItems, weight } = editInfo ?? {};
    const hu = packagingItems?.reduce((total, item) => total + (item.hu || 0), 0);
    const pickupNumber = pickupIdToNumberMap[pickupId];
    return (
      <div className={classes.cardTitleContainer}>
        <div>
          <div className={classes.cardTitlePickupNumber}>
            PRO# <span>{proNumber}</span>
          </div>
          <div className={classes.cardProInfo}>
            PCS<span className={classes.cardProInfoValue}>{pieces || 0}</span>HU
            <span className={classes.cardProInfoValue}>{hu || 0}</span>LBS
            <span className={classes.cardProInfoValue}>{weight || 0}</span>
          </div>
        </div>
        <div className={classes.cardTitleProDetails}>
          <div className={classes.cardTitleProDetailsIndex}>
            PRO <span>{pickupIndex}</span>
          </div>
          <div>
            PICKUP # <span>{pickupNumber}</span>
          </div>
        </div>
      </div>
    );
  };

export default RenderCardTitle;